// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ee259556","455":"8fdd81c5"}[chunkId] + ".chunk.js";
};